import { Link, Paragraph } from '@vimeo/iris/typography';

export default function OnDemand() {
  return (
    <div>
      <Paragraph size="2">
        <em>Vimeo On Demand</em> is a marketplace for films, series, and other member-produced
        videos. For more information, see our Help Center FAQs for{' '}
        <Link
          variant="minimal"
          href="https://help.vimeo.com/hc/en-us/articles/12426085793553-Purchased-VODs-FAQ"
        >
          On Demand purchases
        </Link>{' '}
        or{' '}
        <Link
          variant="minimal"
          href="https://help.vimeo.com/hc/en-us/articles/12427367676433-VOD-Seller-FAQs"
        >
          On Demand sales
        </Link>
        .
      </Paragraph>

      <Paragraph size="2">Use the API to complete the following tasks:</Paragraph>
    </div>
  );
}
